import React, { Component } from 'react'
import { connect } from 'react-redux'

class Row extends Component {

  constructor (props) {
    super(props)
    this.state = {

    }
  }

  render () {
    return (
      <div className='element row clearfix'>
        {this.props.children}
      </div>
    )
  }

}

Row.contextTypes = {
  router: React.PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {

})(Row)



// WEBPACK FOOTER //
// ./src/app/shared/elements/row/index.js